@if (landingPage$ | async; as page) {
  <!--@defer (hydrate on idle) {-->
  @if (!page.header.simple) {
    <app-header-slider [headers]="(slides$ | async) ?? []"></app-header-slider>
  } @else {
    <app-header-article
      [subtitle]="page.header.subtitle"
      [title]="page.header.title"
      [intro]="page.header.intro"
      [media]="page.header.image"
      [button]="page.header.button"
    ></app-header-article>
  }
  <!--}-->
  <app-content-block-container [blocks]="page.contentBlocks"></app-content-block-container>
}
